var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        [
          _vm.renderComponent
            ? _c("v-simple-table", {
                attrs: { "fixed-header": "", height: "400px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "top",
                      fn: function () {
                        return [
                          _c("v-progress-linear", {
                            attrs: {
                              indeterminate: "",
                              color: _vm.loadingTable ? "yellow darken-2" : "",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Dia/Horario"),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Aceite"),
                              ]),
                              _c("th", { staticClass: "text-center" }, [
                                _vm._v("Motivo"),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Justificativa"),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Observação Coordenador."),
                              ]),
                              _c("th", { staticClass: "text-left" }, [
                                _vm._v("Data"),
                              ]),
                              _c("th", { staticClass: "text-center" }),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.item.processItems, function (item2, i) {
                              return _c("tr", { key: i }, [
                                _c("td", { staticClass: "text-no-wrap" }, [
                                  _vm._v(" " + _vm._s(item2.description) + " "),
                                ]),
                                _c("td", [
                                  item2.attribution_process_status_id == 1
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v(" mdi-progress-clock ")]
                                          ),
                                          _c("br"),
                                          _c("small", [
                                            _vm._v("Pendente de Envio"),
                                          ]),
                                        ],
                                        1
                                      )
                                    : item2.attribution_process_status_id == 2
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v(" mdi-progress-clock ")]
                                          ),
                                          _c("br"),
                                          _c("small", [
                                            _vm._v("Pendende de Aceite"),
                                          ]),
                                        ],
                                        1
                                      )
                                    : item2.attribution_process_status_id == 3
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "error" } },
                                            [_vm._v(" mdi-thumb-down-outline ")]
                                          ),
                                          _c("br"),
                                          _c("small", [_vm._v("Recusada")]),
                                        ],
                                        1
                                      )
                                    : item2.attribution_process_status_id == 4
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v(" mdi-thumb-up-outline ")]
                                          ),
                                          _c("br"),
                                          _c("small", [_vm._v("Aceita")]),
                                        ],
                                        1
                                      )
                                    : item2.attribution_process_status_id == 5
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v(" mdi-timer-off-outline ")]
                                          ),
                                          _c("br"),
                                          _c("small", [_vm._v("Expirada")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c("td", [_vm._v(_vm._s(item2.reaser))]),
                                _c("td", [_vm._v(_vm._s(item2.justification))]),
                                _c("td", [_vm._v(_vm._s(item2.note_user))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm._f("dateTime")(item2.created_at))
                                  ),
                                ]),
                                _c("td"),
                              ])
                            }),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2534269146
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }